import { GET_PROFESSION } from "../../../constants/ProfessionConstants";
import { SUCCESS } from "../../../constants/BaseConstants";

export default function setProfessionAction(profession: Profession) {
    return {
        type: GET_PROFESSION + SUCCESS,
        profession
    };
}
